import { Typography } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';

const Help = () => {
	const [caption, setCaption] = useState<any>('');
	useEffect(() => {
		axios({
			url: `/settings/guide_site`,
		}).then(res => {
			if (res.data.success) {
				setCaption(res.data.data.guide_site);
			}
		});
	}, []);
	return (
		<div className="flex min-h-80 w-full flex-col items-center justify-center gap-4 md:flex-row md:gap-11">
			<img src="/images/campaigns/guide.svg" className="h-full w-1/2 md:w-1/6" />
			{/*todo: change colors*/}
			<div className="rounded-lg bg-gradient-to-r from-secondary-main to-primary-main p-[1px]">
				<div className="rounded-lg bg-background-paper">
					<div className="rounded-lg bg-gradient-to-r from-secondary-focus to-primary-focus p-4 md:p-6">
						<Typography className="text-justify text-sm md:text-base">{caption}</Typography>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Help;
